import { createRoot } from "react-dom/client";
import React from 'react';
import App from './App';
import './i18n';
import './local';
import './portal.css';
import '@ant-design/v5-patch-for-react-19';

const win: any = window;
!!!win["lang"] && (win["lang"] = "en");
document.documentElement.lang = win["lang"];
!!!win['googleMapKey'] && (win['googleMapKey'] = import.meta.env.VITE_GMK);

const lang = win['lang']
const rtl = lang === 'ar';

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode >
    <App rtl={rtl} />
  </React.StrictMode>
);

